/**
 * A custom Set implementation that covers requirements for web source code:
 * 1. when the .add() is called, make sure the argument is placed or moved to end of the end (last touch)
 * 2. provide serialization functions that use the custom delimiter
 */
export class WebSourceCodesSet {
  dataset = new Set<string>()
  delimiter = '*|*'

  constructor(code?: string | null) {
    this.init(code)
  }

  init(code?: string | null) {
    if (!code) return
    this.set(this.deserialize(code))
  }

  set(codes?: string[] | null) {
    if (!codes) return
    this.dataset = new Set(codes)
  }

  add(code?: string | null) {
    if (!code) return
    this.dataset.delete(code)
    this.dataset.add(code)
  }

  delete(code?: string | null) {
    if (!code) return
    this.dataset.delete(code)
  }

  has(code: string) {
    return this.dataset.has(code)
  }

  serialize() {
    return decodeURIComponent(Array.from(this.dataset).join(this.delimiter))
  }

  deserialize(code?: string | null) {
    if (!code) return []
    // Cookies are encoded by default by next
    return decodeURIComponent(code).split(this.delimiter)
  }
}
